import * as React from 'react';

import { start as fullStoryInit } from 'js/lib/fullstory';
import { useLocation } from 'js/lib/useRouter';

import GrowthDiscoveryExperiments from 'bundles/epic/clients/GrowthDiscovery';
import PageFooter from 'bundles/page-footer/components/PageFooter';
import PageHeader from 'bundles/page-header/components/PageHeader';
import InternalError from 'bundles/promo-template/components/InternalError';
import NotFound from 'bundles/promo-template/components/NotFound';
import PagePlaceholder from 'bundles/promo-template/components/PagePlaceholder';
import { DOMAINS } from 'bundles/promo-template/constants/navigation';
import PageContent from 'bundles/promo-template/contentful/pages/PageContent';
import { PromoTemplateDomainContext } from 'bundles/promo-template/contexts/PromoTemplateDomainContext';
import usePageContentQuery from 'bundles/promo-template/queries/hooks/usePageContentQuery';

type Props = {
  slug: string;
};

const FULLSTORY_MONITORED_DOMAINS = [DOMAINS.explore] as const;

const PromoTemplatePage = ({ slug }: Props) => {
  const { domain } = React.useContext(PromoTemplateDomainContext);
  const { loading, page, error } = usePageContentQuery(slug, domain);
  const { pathname } = useLocation();

  if (loading) {
    return <PagePlaceholder />;
  }

  if (error || !page) {
    if (error?.graphQLErrors?.[0]?.extensions?.errorType === 'NOT_FOUND' || !page) {
      return <NotFound />;
    }

    return <InternalError pathname={pathname} />;
  }

  if (FULLSTORY_MONITORED_DOMAINS.includes(domain) && GrowthDiscoveryExperiments.get('enableSelfServePageFullStory')) {
    fullStoryInit({ disableForCourserians: true });
  }

  return (
    <>
      <PageHeader hideMetaNav showGDPRBanner showLanguagesDropdown />
      <main>
        <PageContent slug={slug} domain={domain} pageData={page} />
      </main>
      <PageFooter isDirectoryPage />
    </>
  );
};

export default PromoTemplatePage;
